export const MENU = '/api/v1/menus/for-parent';
